var map = {
	"./Adaptive_Logo.png": 770,
	"./Crest_logo.png": 771,
	"./Crown_logo.png": 772,
	"./Marquis_logo.png": 773,
	"./RESTORE-Logo.png": 774,
	"./aventura.png": 775,
	"./castle_logo.png": 776,
	"./logo_reliant.jpg": 777,
	"./synergycare_logo.png": 778,
	"./thesprings_logo.png": 779,
	"./wellstone_logo.png": 780
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 769;


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/business_group_logos nonrecursive \.(png|jpe?g|svg)$
// module id = 769
// module chunks = 0